import React from "react";
import logo from "../assets/whatsapp.svg";

const Chat = () => {
  const whatsappNumber = "34611591919"; // Remove '+' for URL
  const message = "¡Hola!";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="dropdown dropup chat_drop w-100" id="chat">
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex align-items-center justify-content-center chat_icon"
      >
        <img src={logo} height={52} />
      </a>
    </div>
  );
};

export default Chat;
